import axios from 'axios'
import { BUSCAR_ENCOMENDA_AVULSA } from '../types'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarEncomendaAvulsaPorId (idEncomendaAvulsa, idEmpresa) {
  const url = `${URL}/encomendas-avulsas/${idEncomendaAvulsa}/empresa/${idEmpresa}`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => dispatch({
      type: BUSCAR_ENCOMENDA_AVULSA,
      payload: response.data
    })
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      return dispatch({ type: BUSCAR_ENCOMENDA_AVULSA, payload: null })
    }
    throw erro
  })
}
